import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0723b072"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Imagens meramente ilustrativas", -1))
const _hoisted_3 = { class: "text-desconto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" DE DESCONTO")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Ativada ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout",
  src: "/assets/icon/descontos.svg"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Ative aqui seus ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "DESCONTOS EXCLUSIVOS", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lojafisica" }, "VÁLIDO APENAS PARA LOJA FÍSICA", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Para utilizar os descontos ativados, informe o seu ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "CPF", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" em um dos nossos caixas. ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_layout_title",
  src: "/assets/icon/descontos.svg"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Ofertas Exclusivas ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Estamos separando ofertas incríveis para você, aqui você terá as melhores promoções para comprar em nossas lojas físicas. ")
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "text-oferta" }
const _hoisted_26 = { class: "text-desconto" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " DE DESCONTO ", -1))
const _hoisted_28 = { class: "text-validade" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Ativada ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.isOpenRef,
        header: "Ativação",
        "sub-header": "Important message",
        message: "Ativado com sucesso",
        buttons: ['OK'],
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_ion_loading, { "is-open": _ctx.isOpenLoading }, null, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "backdrop-dismiss": true,
        canDismiss: true,
        "is-open": _ctx.isOpenDetalhes,
        onIonModalDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenDetalhes=false)),
        "initial-breakpoint": 0.80,
        breakpoints: [0.8, 0.75]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding produto_show" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenDetalhes=false)),
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        width: "240",
                        class: "produto-imagem",
                        src: _ctx.oferta.imagem
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center small",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "text-oferta",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.oferta.nomeoferta), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.oferta.percentualdesconto+'%') + " ", 1),
                        _hoisted_4
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "text-validade",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.oferta.validade), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "precofull",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      (_ctx.oferta.ativado)
                        ? (_openBlock(), _createBlock(_component_ion_badge, {
                            key: 0,
                            color: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_footer, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            disabled: _ctx.oferta.ativado,
                            color: _ctx.oferta.ativado ? 'light':'jauservelayoutalter',
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.putOfertas(_ctx.oferta))),
                            shape: "jau"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.oferta.ativado ? 'Expira em ' + _ctx.oferta.diasexpiracao + ' dias' : 'Ativar Desconto'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.70,
        breakpoints: [0, 0.75]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper, {
                pagination: true,
                modules: _ctx.modules,
                autoplay: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b1",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat-medium font-30 layout_blue",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9,
                              _hoisted_10,
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "2" }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat-medium font-30 layout_blue",
                            size: "8"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b3",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13,
                              _hoisted_14,
                              _hoisted_15,
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[4] || (_cache[4] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat layout_blue font-25"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.ofertas.length==0)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-align-items-center bg_white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center on-align-items-center b2",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ofertas, (oferta, index) => {
                return (_openBlock(), _createBlock(_component_ion_col, {
                  class: "ion-text-center on-align-items-center divider-right",
                  key: index,
                  size: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_thumbnail, {
                      onClick: ($event: any) => (_ctx.showOferta(oferta)),
                      class: "ion-text-center on-align-items-center"
                    }, {
                      default: _withCtx(() => [
                        (oferta.nomeoferta == ' ')
                          ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                              key: 0,
                              animated: true
                            }))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: oferta.imagem
                            }, null, 8, _hoisted_22))
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        (oferta.nomeoferta == ' ')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%","height":"15px"}
                              }),
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%"}
                              }),
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%"}
                              }),
                              _createVNode(_component_ion_skeleton_text, {
                                animated: true,
                                style: {"width":"100%","height":"25px"}
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(oferta.nomeoferta), 1),
                              _createElementVNode("span", _hoisted_26, [
                                _createTextVNode(_toDisplayString(oferta.percentualdesconto+'%') + " ", 1),
                                _hoisted_27
                              ]),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(oferta.validade), 1),
                              _hoisted_29,
                              (oferta.ativado)
                                ? (_openBlock(), _createBlock(_component_ion_badge, {
                                    key: 0,
                                    color: "jauservelayoutverde"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _hoisted_31,
                              _createVNode(_component_ion_button, {
                                disabled: oferta.ativado,
                                color: oferta.ativado ? 'jauservelayoutverde':'jauservelayoutalter',
                                onClick: ($event: any) => (_ctx.putOfertas(oferta)),
                                expand: "block",
                                shape: "jau"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(oferta.ativado ? 'Expira em ' + oferta.diasexpiracao + ' dias' : 'Ativar Desconto'), 1)
                                ]),
                                _: 2
                              }, 1032, ["disabled", "color", "onClick"])
                            ]))
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_32
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:true} })
    ]),
    _: 1
  }))
}